import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {BaseDatepickerComponent} from './base-datepicker.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE, provideNativeDateAdapter} from '@angular/material/core';
import {FormsModule} from '@angular/forms';
import {MONTH_YEAR_FORMAT} from '../../utils/date-formats';
import {environment} from '../../../../environments/environment';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-month-datepicker',
  standalone: true,
  imports: [BaseDatepickerComponent, MatFormFieldModule, MatDatepickerModule, MatInputModule, MatIconModule, MatButtonModule, FormsModule, DatePipe],
  providers: [provideNativeDateAdapter(), {provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMAT}, {provide: MAT_DATE_LOCALE, useValue: environment.locale}],
  template: `
    <div class="datepicker-container">
      <button mat-icon-button (click)="decrementDate()" class="datepicker-arrow-button">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <app-base-datepicker [date]="date" (dateChange)="onDateChange($event)">
        <div class="datepicker-container">
          <span class="datepicker-label">{{ date | date : 'MMMM yyyy' : undefined : locale }}</span>
          <mat-form-field appearance="fill" class="datepicker-field" appMonthYearFormat>
            <input matInput [matDatepicker]="picker" [(ngModel)]="date" readonly class="hidden-input" />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker
              #picker
              startView="multi-year"
              (monthSelected)="onMonthSelected($event, picker)"
              panelClass="month-picker"
              [startView]="'year'"
              [touchUi]="true"
            ></mat-datepicker>
          </mat-form-field>
        </div>
      </app-base-datepicker>
      <button mat-icon-button (click)="incrementDate()" class="datepicker-arrow-button">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./datepicker.component.css'],
})
export class MonthDatepickerComponent {
  readonly locale = environment.locale;
  @Input() date: Date = new Date();
  @Output() dateChange = new EventEmitter<Date>();

  onDateChange(newDate: Date) {
    this.date = newDate;
    this.dateChange.emit(newDate);
  }

  onMonthSelected(month: Date, datepicker: any) {
    this.date = month;
    this.dateChange.emit(month);
    datepicker.close();
  }

  incrementDate() {
    const newDate = new Date(this.date);
    newDate.setMonth(newDate.getMonth() + 1);
    this.date = newDate;
    this.dateChange.emit(newDate);
  }

  decrementDate() {
    const newDate = new Date(this.date);
    newDate.setMonth(newDate.getMonth() - 1);
    this.date = newDate;
    this.dateChange.emit(newDate);
  }
}
